import { Box, useColorModeValue } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

import { TopNavbar } from "../TopNavbar";
import { DownloadManagerPanel } from "../DownloadManagerPanel";

export const Layout = () => {
  const bg = useColorModeValue("#f5f5f5", "#0a1628");

  return (
    <Box minHeight="100vh" bg={bg}>
      <TopNavbar />
      <Box pt="80px" height="100%">
        <Outlet />
      </Box>
      <DownloadManagerPanel />
    </Box>
  );
};
